import React from 'react';
import './Carousel.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel';

function Carousel() {
  const images = [
    '2024-06-08at18.12.01.jpeg',
    '2024-06-10at08.54.20.jpeg',
    '2024-06-23at19.03.42.jpeg',
    '2024-07-13at21.46.11.jpeg',
    '2024-07-13at21.46.12.jpeg',
    '2024-07-13at22.02.35.jpeg',
    '2024-09-07at18.54.24.jpeg',
    '2024-09-14at19.53.10.jpeg',
  ];
  
  return (
    <ResponsiveCarousel
    showThumbs={false}
    infiniteLoop
    useKeyboardArrows
    autoPlay
    autoFocus
    dynamicHeight={true}
    interval={5000}
    transitionTime={2000}
  >
    {images.map((img, index) => (
      <div key={index}>
        <img src={`/images/home-carousel/${img}`} />
      </div>
    ))}
  </ResponsiveCarousel>
  );
}

export default Carousel;
